import React, { useState, useRef, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import { FaHandsHelping, FaThumbsUp, FaUserCheck,FaNewspaper } from 'react-icons/fa';

const operator = require("./images/operator.PNG");

function AppointmentForm() {
  const [submitted, setSubmitted] = useState(false);
  const [timer, setTimer] = useState(300); // 5 minutes in seconds
  const form = useRef(); // Form reference

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimer(300); // Reset timer to 5 minutes

    // Send the form data using emailjs.sendForm() with form reference
    emailjs.sendForm('service_3y0dv6n', 'template_sp3supv', form.current, 'dmKCr8p3g87ZauD3Z')
      .then((result) => {
        console.log("EmailJS Success: ", result.text);
      }, (error) => {
        console.log("EmailJS Error: ", error.text);
      });
  };

  useEffect(() => {
    let interval;
    if (submitted && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
      setSubmitted(false); // Reset submission state after countdown ends
    }
    return () => clearInterval(interval);
  }, [submitted, timer]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
  };

  return (
    <div className="max-w-6xl mx-4 sm:mx-auto p-4 bg-gray-50 rounded-xl shadow-lg my-8" id="appointment">
      
      <h2 className='mb-2 text-gray-800 text-4xl font-extrabold'>Tired of Hearing “We’ll Come Next Week”?</h2>
      <p className='text-gray-500'>Appliance broke? Plumbing leak? Lights out — and no one’s picking up the phone?
We get it — when something breaks, you need help now, not next Tuesday.
90% of our service calls are completed the same day. Fast. Reliable. No excuses.</p>
      <ul className='my-6 text-md md:text-xl font-bold space-y-4'>
        <li className='flex'> <FaUserCheck className='text-3xl text-red-400 mr-2' /> 7 Days a Week Availability</li>
        <li className='flex'> <FaNewspaper className='text-3xl text-red-400 mr-2' /> Licensed & Experienced Techs</li>
        <li className='flex'> <FaHandsHelping className='text-3xl text-red-400 mr-2' /> Real-Time Phone & Online Support</li>
        <li className='flex'> <FaThumbsUp className='text-3xl text-red-400 mr-2' / >Warranty on All Repairs</li>
        </ul>
      <h3><span className='text-xl text-red-500 font-extrabold mb-6'>(346) 800-2250</span> — Call us, even if it’s urgent</h3>
      
      <h2 className='my-4 text-gray-600 text-4xl font-extrabold'>Appointment form</h2>
      <p className='mb-4 text-gray-400'>Schedule your appointment in less than a minute – quick, easy, and hassle-free!</p>
      {!submitted ? (
        // Form Section
        <form onSubmit={handleSubmit} ref={form}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input
              type="text"
              name="name"
              placeholder="Name"
              className="p-2 border rounded"
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              className="p-2 border rounded"
              required
            />
            <input
              type="date"
              name="date"
              className="p-2 border rounded"
              required
            />
            <select
            type="text"
              name="time"
              className="p-2 border rounded"
              required
            >
              <option value="">Select Time Range</option>
              <option value="8AM-12PM">8AM-12PM</option>
              <option value="12PM-4PM">12PM-4PM</option>
              <option value="4PM-8PM">4PM-8PM</option>
            </select>
            <input
            type="email"
              name="email"
              placeholder="Email address"
              className="p-2 border rounded"
              required
            />
            <textarea
              type="textarea"
              name="issue"
              placeholder="Issue Details (max 100 characters)"
              className="p-2 border rounded"
              maxLength="100"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full mt-6 py-2 bg-blue-500 text-white text-lg font-bold rounded-xl hover:bg-blue-600 transition duration-200"
          >
            Find handyman near me
          </button>
        </form>
      ) : (
        // Memory Match Game Section
        <div className="text-center">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">We are looking for a suitable handyman in your area</h3>
          <div className="text-4xl font-bold text-blue-600 mb-4">
            {formatTime(timer)}
          </div>
          <p className="mb-6 text-gray-500">Please hold on while we process your request.</p>

          {/* Memory Match Game Area */}
          <div className="mx-auto w-64 rounded-2xl shadow-xl">
            <img src={operator} alt="operator-looking-for-handyman"/>
          </div>
        </div>
      )}
    </div>
  );
}

export default AppointmentForm;
